import _WeakMap from "@babel/runtime-corejs3/core-js/weak-map";
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/esm/objectWithoutProperties";
import _typeof from "@babel/runtime-corejs3/helpers/esm/typeof";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime-corejs3/helpers/esm/inherits";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import _classPrivateFieldGet from "@babel/runtime-corejs3/helpers/esm/classPrivateFieldGet";
import React, { Component } from "react";
import PropTypes from "prop-types";

var determineHasValue = function determineHasValue(val) {
  return val != null && val.toString().length > 0;
};

var Input =
/*#__PURE__*/
function (_Component) {
  _inherits(Input, _Component);

  function Input() {
    var _getPrototypeOf2, _context;

    var _this;

    _classCallCheck(this, Input);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Input)).call.apply(_getPrototypeOf2, _concatInstanceProperty(_context = [this]).call(_context, args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      // `hasValue` emulates the behavior of React's `input`
      hasValue: determineHasValue(_this.props.defaultValue) || determineHasValue(_this.props.value)
    });

    _handleInputRef.set(_assertThisInitialized(_this), {
      writable: true,
      value: function value(input) {
        if (input) {
          _classPrivateFieldGet(_assertThisInitialized(_this), _updateState).call(_assertThisInitialized(_this), input.value);
        }

        if (typeof _this.props.inputRef === 'function') {
          _this.props.inputRef(input);
        }

        if (_this.props.inputRef && _typeof(_this.props.inputRef) === 'object') {
          _this.props.inputRef.current = input;
        }
      }
    });

    _handleChange.set(_assertThisInitialized(_this), {
      writable: true,
      value: function value(evt) {
        var value = evt.currentTarget.value;

        _classPrivateFieldGet(_assertThisInitialized(_this), _updateState).call(_assertThisInitialized(_this), value);

        if (typeof _this.props.onChange === 'function') {
          _this.props.onChange(evt);
        }
      }
    });

    _updateState.set(_assertThisInitialized(_this), {
      writable: true,
      value: function value() {
        var _value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

        _this.setState({
          hasValue: _value.toString().length > 0
        });
      }
    });

    return _this;
  }

  _createClass(Input, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.value !== prevProps.value) {
        _classPrivateFieldGet(this, _updateState).call(this, this.props.value);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onChange = _this$props.onChange,
          inputRef = _this$props.inputRef,
          value = _this$props.value,
          defaultValue = _this$props.defaultValue,
          props = _objectWithoutProperties(_this$props, ["onChange", "inputRef", "value", "defaultValue"]);

      var controlledProps;

      if (this.props.defaultValue != null) {
        controlledProps = {
          defaultValue: defaultValue
        };
      } else {
        controlledProps = {
          value: value
        };
      }

      if (this.state.hasValue) {
        props['data-has-value'] = '';
      }

      return React.createElement("input", _extends({
        ref: _classPrivateFieldGet(this, _handleInputRef),
        onChange: _classPrivateFieldGet(this, _handleChange)
      }, controlledProps, props));
    }
  }]);

  return Input;
}(Component);

var _handleInputRef = new _WeakMap();

var _handleChange = new _WeakMap();

var _updateState = new _WeakMap();

export { Input as default };
process.env.NODE_ENV !== "production" ? Input.propTypes = {
  onChange: PropTypes.func,

  /**
   * Pass ref to input to control things such as focus using React 15.x refs API. Doc:
   * https://react-legacy.netlify.com/docs/refs-and-the-dom.html
   */
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape()
  })]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool])
} : void 0;